import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionBasedComponent } from '../../../subscription-helpers/subscription-based.component';
import { PRODUCTS } from '../../../helpers/constants';

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss'],
})
export class ProductDetailComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  parameterName: string;

  constructor(private activated: ActivatedRoute) {
    super();
  }

  ngOnInit() {
    this.addSubscription(this.activated.params, (params) => {
      this.parameterName = params.name;
    });
  }

  protected readonly PRODUCTS = PRODUCTS;
}
